<div class="app flex-row align-items-center not-found-page">
    <div class="container d-flex justify-content-center">
        <div class="row">
            <div class="col-12">
                <div class="error-img">
                    <img src="assets/images/page not found.svg">
                </div>
                <div class="input-prepend input-group d-flex justify-content-center mt-3">
                    <button [routerLink]="['']" class="primary-btn" type="button">
                <i class="fa fa-arrow-left"></i>&nbsp;Go to Home
              </button>
                </div>
            </div>
        </div>
    </div>
</div>